import ArticleLayout from "../components/ArticleLayout";

export default function PerfumesGuide() {
  return <ArticleLayout articleId={13} />;
}